import striptags from 'striptags';

import { CoverImage, Date } from '@components';
import { postPath } from '@paths';
import { addTrailingSlash } from '@utils';

export const PostCard: React.FC<{
  title: any; // TODO
  coverImage: any; // TODO
  date: any; // TODO
  excerpt: any; // TODO
  slug: any; // TODO
  isHeroPost?: boolean;
  className?: string;
  alternativePostPath?: string;
}> = ({
  title,
  coverImage,
  date,
  excerpt,
  slug,
  className,
  isHeroPost,
  alternativePostPath,
}) => {
  const postHref = postPath(slug, alternativePostPath);
  return (
    <div className={`flex flex-col bg-lightgray ${className || ''}`}>
      <div>
        {coverImage && (
          <CoverImage
            title={title}
            coverImage={coverImage}
            href={postHref}
            large={isHeroPost}
          />
        )}
      </div>
      <div className='flex h-full flex-col p-[18px]'>
        <div
          className={`mb-2 text-sm font-bold ${
            isHeroPost ? 'lg:text-base' : ''
          }`}
        >
          <Date dateString={date} />
        </div>
        <h3
          className={`mb-2 text-xl text-primary ${
            isHeroPost ? 'lg:text-2xl' : ''
          } font-bold leading-tight`}
        >
          {/* prefetchさせない/spa動作させないためにnext/linkを使わない */}
          <a
            href={addTrailingSlash(postHref)}
            className='hover:underline'
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </h3>
        <div
          className={`mt-auto line-clamp-3 text-sm font-bold ${
            isHeroPost ? 'lg:text-base' : ''
          }`}
        >
          {striptags(excerpt).replace('[&hellip;]', '...')}
        </div>
      </div>
    </div>
  );
};
